module.exports = __webpack_public_path__ + "static/bg-splash-a8027bbd8289e2bbce3e3f2d69d80fe1.png";